"use strict";
/**
 * Builds the `info` markdown tab shown on the Use Case Details page.
 * Stitches together the AI-use-case overview, the summary table, and the
 * per-section value/list blocks pulled from the draft.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildInfoTabMarkdown = void 0;
var prioritisation_1 = require("../../shared/utils/prioritisation");
var markdown_text_1 = require("./markdown-text");
var field_coercion_1 = require("./field-coercion");
var buildSummaryRows = function (useCase, output, title) {
    var _a;
    var draft = output === null || output === void 0 ? void 0 : output.Draft;
    return [
        ['Use Case ID', "" + (((_a = output === null || output === void 0 ? void 0 : output.AiUseCase) === null || _a === void 0 ? void 0 : _a.id) || useCase.id)],
        ['Title', "" + (title || '-')],
        ['Output Version', "" + ((output === null || output === void 0 ? void 0 : output.Version) || '-')],
        ['Target System ID', field_coercion_1.getTargetSystemId(output)],
        [
            'Priority',
            "" + (field_coercion_1.getOutputFieldValue(output, ['Priority']) || (draft === null || draft === void 0 ? void 0 : draft.Priority) || useCase.fields.Priority || useCase.fields.priority || '-'),
        ],
        [
            'Users Impacted',
            "" + (field_coercion_1.getOutputFieldValue(output, ['NoOfUsersImpacted']) || (draft === null || draft === void 0 ? void 0 : draft.NoOfUsersImpacted) || '-'),
        ],
        [
            'Created By',
            "" + (field_coercion_1.getOutputFieldValue(output, ['OwnerName', 'Owner']) || (draft === null || draft === void 0 ? void 0 : draft.UserName) || field_coercion_1.coerceFieldValueToString(useCase.fields.createdBy) || '-'),
        ],
        ['Created At', field_coercion_1.formatCreatedAt(draft === null || draft === void 0 ? void 0 : draft.CreatedAt)],
        ['Manual Entry', (draft === null || draft === void 0 ? void 0 : draft.IsManual) ? 'Yes' : 'No'],
    ];
};
var buildDraftSections = function (output) {
    var draft = output === null || output === void 0 ? void 0 : output.Draft;
    if (!draft) {
        return [];
    }
    return [
        markdown_text_1.toMarkdownValueOrList('Objective', field_coercion_1.getOutputFieldValue(output, ['Objective']) || draft.Objective),
        markdown_text_1.toMarkdownValueOrList('Pain Point', field_coercion_1.getOutputFieldValue(output, ['PainPoint', 'PainPoints']) || draft.PainPoint),
        markdown_text_1.toMarkdownValueOrList('Target Audience', field_coercion_1.getOutputFieldValue(output, ['TargetAudience']) || draft.TargetAudience),
        markdown_text_1.toMarkdownValueOrList('Technology Stack', field_coercion_1.getOutputFieldValue(output, ['TechnologyStack']) || draft.TechnologyStack),
        markdown_text_1.buildMarkdownListSection('Process', markdown_text_1.splitOrderedListValues(field_coercion_1.getOutputFieldValue(output, ['Process']) || draft.Process), true),
        markdown_text_1.toMarkdownValueOrList('Impact', field_coercion_1.getOutputFieldValue(output, ['Impact']) || draft.Impact),
        markdown_text_1.toMarkdownValueOrList('Risk', field_coercion_1.getOutputFieldValue(output, ['Risk']) || draft.Risk),
        markdown_text_1.toMarkdownValueOrList('Usage', field_coercion_1.getOutputFieldValue(output, ['UsageStats']) || draft.UsageStats),
        markdown_text_1.toMarkdownValueOrList('Time Saving', field_coercion_1.getOutputFieldValue(output, ['TimeSaving']) || draft.TimeSaving),
        markdown_text_1.toMarkdownValueOrList('Other Info', draft.OtherInfo),
    ];
};
var buildPrioritisationSection = function (useCase, strategies) {
    var prioritisationEntries = prioritisation_1.getPrioritisationScoreEntries(useCase.fields.Prioritisation);
    if (prioritisationEntries.length === 0) {
        return ['## Prioritisation', 'This use case has not yet been prioritised.'];
    }
    var strategyNameById = strategies.reduce(function (result, strategy) {
        result[String(strategy.id)] = strategy.name;
        return result;
    }, {});
    var rows = prioritisationEntries.map(function (entry) {
        var _a;
        return [
            (_a = strategyNameById[entry.strategyId]) !== null && _a !== void 0 ? _a : "Strategy " + entry.strategyId,
            prioritisation_1.formatPrioritisationScore(entry.score),
        ];
    });
    return ['## Prioritisation', markdown_text_1.buildMarkdownTable(['Strategy', 'Prioritisation Score'], rows)];
};
/**
 * Build the default info tab markdown from use case and draft fields.
 */
exports.buildInfoTabMarkdown = function (useCase, output, strategies) {
    var _a, _b, _c;
    var title = ((_a = output === null || output === void 0 ? void 0 : output.AiUseCase) === null || _a === void 0 ? void 0 : _a.title) || useCase.title;
    var overview = ((_b = output === null || output === void 0 ? void 0 : output.AiUseCase) === null || _b === void 0 ? void 0 : _b.description) ||
        field_coercion_1.getOutputFieldValue(output, ['Objective', 'description']) || ((_c = output === null || output === void 0 ? void 0 : output.Draft) === null || _c === void 0 ? void 0 : _c.Objective) ||
        "" + (useCase.fields.description || '-');
    var sections = ['# Use Case', '## Overview', markdown_text_1.normalizeReportText(overview)];
    sections.push.apply(sections, buildPrioritisationSection(useCase, strategies));
    var summaryTable = markdown_text_1.buildMarkdownTable(['Field', 'Value'], buildSummaryRows(useCase, output, title));
    if (summaryTable) {
        sections.push('## Summary');
        sections.push(summaryTable);
    }
    sections.push.apply(sections, buildDraftSections(output));
    return sections.filter(Boolean).join('\n\n');
};
